import { InputField } from 'components'
import ProductPatternSchema from './product-pattern-form-schema'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { LoaderButton } from 'components/molecules'
import ProductPatternImageField from 'domains/product-pattern/molecules/image-upload-field'

const propTypes = {
  handleSubmit   : PropTypes.func.isRequired,
  productPattern : PropTypes.object
}

const ProductPatternForm = ({ handleSubmit, productPattern }) => (
  <Formik
    initialValues={{
      label : productPattern?.label,
      image : ''
    }}
    validationSchema={ ProductPatternSchema }
    onSubmit={ handleSubmit }
  >
    {
      (formikBag) => (
        <Form>
          <InputField
            type="text"
            label="Label"
            name="label"
            required={ true }
          />

          <ProductPatternImageField
            label='Image'
            name='image'
            expectedDimension={{ width: 150, height: 150 }}
            imageUrl={ productPattern?.image_url }
            formikBag={ formikBag }
          />

          <LoaderButton
            isLoading={ formikBag.isSubmitting }
            block={ false }
            color='primary'
            type='submit'
            text="Save"
          />
        </Form>
      )
    }
  </Formik>
)

ProductPatternForm.propTypes = propTypes

export default ProductPatternForm
